import { Logger as SERVICE_WORKER_Logger } from '../../../../ServiceWorker/src/helpers/logger';

export { SERVICE_WORKER_Logger as Logger };
